// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.em-classes {
  cursor: pointer;
  color: #0a6ed1;
  font-size: 1em;
  line-height: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/metric-link-renderer/metric-link-renderer.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AACJ","sourcesContent":[".em-classes {\n    cursor: pointer;\n    color: #0a6ed1;\n    font-size: 1em;\n    line-height: 0.8;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
